import type { TrackedPackage } from '../lib/trackingService';
import { getStatusExportLabel } from './trackingStatusHelpers';

export function exportTrackingToCSV(
  packages: TrackedPackage[],
  filename?: string
): void {
  const headers = [
    'Order Number',
    'Customer Name',
    'Tracking Code',
    'PostNL Tracking URL',
    'Service Type',
    'Product Code',
    'Destination City',
    'Destination Country',
    'Delivery Status',
    'Shipped Date',
    'Last Updated',
  ];

  const rows = packages.map((pkg) => {
    const city = pkg.shipping_address?.city || '';
    const country = pkg.shipping_address?.country || pkg.shipping_address?.country_code || '';
    const postalCode = pkg.shipping_address?.zip || '';
    const countryCode = pkg.shipping_address?.country_code || 'NL';
    const trackingUrl = `https://postnl.nl/tracktrace/?B=${encodeURIComponent(pkg.tracking_code)}&P=${encodeURIComponent(postalCode)}&D=${encodeURIComponent(countryCode)}&T=C`;

    const serviceLabel = pkg.service_type === 'mailbox' ? 'Buspakje' : pkg.service_type === 'package' ? 'Pakje' : '';

    return [
      pkg.order_number,
      pkg.customer_name || '',
      pkg.tracking_code,
      trackingUrl,
      serviceLabel,
      pkg.product_code || '',
      city,
      country,
      getStatusExportLabel(pkg.delivery_status),
      pkg.fulfilled_at
        ? new Date(pkg.fulfilled_at).toLocaleDateString()
        : new Date(pkg.order_date).toLocaleDateString(),
      pkg.last_tracking_update
        ? new Date(pkg.last_tracking_update).toLocaleString()
        : '',
    ];
  });

  const csvContent = [
    headers.map(escapeCSV).join(','),
    ...rows.map((row) => row.map(escapeCSV).join(',')),
  ].join('\n');

  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || `package-tracking-export-${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

function escapeCSV(value: string | number | null | undefined): string {
  const str = String(value ?? '');
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}
